export const formatPhone = (dirtyNumber) => {
  if (!dirtyNumber) {
    return ''
  }
  return dirtyNumber
    ?.slice(2)
    .replace(/\D+/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export const internationalPhoneFormat = (phone) => {
  return phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '+$1$2$3')
}

export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
}

export function stringifyAddress(property, debug) {
  const { address, source, unit } = property;
  const addressParts = address.split(",").map((part) => part.trim());
  const addressStr =
    (source &&
      source.address &&
      !address.includes(source.address) &&
      [
        source.address,
        source.city,
        addressParts.length > 3 &&
        addressParts.at(-2) === source.zipcode &&
        addressParts.at(-3).match(/^[A-Z]{2}$/)
          ? addressParts.slice(-3).join(", ")
          : source.zipCode,
      ]
        .filter(Boolean)
        .join(", ")) ||
    address;

  const appendix =
    (debug &&
      ((source && !address?.includes(source.zipcode)) ||
        (source?.address.includes(" -") &&
          unit === "" &&
          "🚩 " +
            JSON.stringify({
              city: source?.city,
              zipcode: source?.zipcode,
              address: source?.address,
            })))) ||
    "";

  return `${addressStr}${appendix}`;
}

// let isPhone = (phone) => {
//   //normalize string and remove all unnecessary characters
//   phone = phone.replace(/\D+/g, '');
//   return phone.length == 10? true : false;
// }
